var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['component--text-icon',_vm.disabled?'text-icon__disabled':null],style:({
        width:_vm.width+'px',
        height:_vm.width+'px',
        lineHeight:_vm.width+'px',
        fontSize:_vm.width/2+'px',
        backgroundColor:_vm.disabled?'gray':_vm.color}),on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }